import styled from 'styled-components';
import bookmarkCheckedIcon from '../../ivy/Home/assets/bookmark_checked.svg';
import bookmarkIcon from '../../ivy/Home/assets/bookmark.svg';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { AuthUtils } from '../../../utils/AuthUtils';
import {
  addBookmark,
  fetchBookmarks,
  removeBookmark,
} from '../../../repository/RecruitmentRepository';
import PopupModal from '../PopupModal';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { BookmarkType } from '../../../types/RecruitmentTypes';
import { BookmarksAtom } from '../../../recoil/Recruitment.recoil';

interface BookmarkProps {
  id: number;
  isBookmarked: boolean;
  setIsBookmarked: Dispatch<SetStateAction<boolean>>;
  isHomeInsight?: boolean
}

const Bookmark = (props: BookmarkProps) => {
  const { id, isBookmarked, setIsBookmarked, isHomeInsight } = props;
  const token = AuthUtils.getCookie('token');
  const isLogin = AuthUtils.isLoggedIn();
  const navigate = useNavigate();
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [bookmarks, setBookmarks] = useRecoilState<BookmarkType[]>(BookmarksAtom);

  const refreshBookmarkList = () => {
    fetchBookmarks(token).then((res) => {
      if (res) {
        setBookmarks(res);
      }
    });
  };
  const editBookmark = (type: 'add' | 'remove') => {
    if (type === 'add') {
      addBookmark(id, token)
        .then((res) => {
          if (res.success) {
            setIsBookmarked(true);
            refreshBookmarkList();
          }
        })
        .catch((e) => console.error(e));
    } else {
      removeBookmark(id, token)
        .then((res) => {
          if (res.success) {
              // 홈 - 채용 인사이트 에서는 북마크 제거시 바로 없어짐
              if(isHomeInsight === undefined) {
                  setIsBookmarked(false);
              }
            refreshBookmarkList();
          }
        })
        .catch((e) => console.error(e));
    }
  };

  return (
    <>
      <PopupModal
        isOpenModal={isOpenModal}
        setIsOpenModal={setIsOpenModal}
        needsCancelBtn={true}
        message={'로그인이 필요합니다. \n로그인 화면으로 이동합니다.'}
        confirmFn={() => navigate('/login')}
      />
      <BookmarkIconBtn type="button">
        <BookmarkIcon
          src={isBookmarked ? bookmarkCheckedIcon : bookmarkIcon}
          alt="북마크 체크 아이콘"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (isLogin) {
              if (!isBookmarked) {
                editBookmark('add');
              } else {
                editBookmark('remove');
              }
            } else {
              setIsOpenModal(true);
            }
          }}
        />
      </BookmarkIconBtn>
    </>
  );
};

export default Bookmark;

const BookmarkIconBtn = styled.button`
  width: 2.8rem;
  background-color: transparent;
`;

const BookmarkIcon = styled.img`
  width: 2.8rem;
  height: 2.8rem;
`;
